import styled from "styled-components";
import {CharcoalBlack} from "../../../../theme/variable";
import {media} from "../../../../theme/responsive";

export const AlreadyReviewedText = styled.div`
    font-size: 0.875rem;
    color: ${CharcoalBlack};
    padding: 30px;
    text-align: center;
    line-height: 21px;
    display: inline-block;
    width: 100%;
    p {
        margin-bottom: 20px;
    }
    ${media.laptop`font-size:1rem;`}
`;
